function upsellingItemsFn() {
  const upsellingItems = document.querySelectorAll('.upselling-container__item');
  if (upsellingItems.length) {
    upsellingItems.forEach(upsell => {
      // Elements
      const imageWrapper = upsell.querySelector('.set-product__image-wrapper');
      const actButton = upsell.querySelector('.set-product__button button');
      const swatches = upsell.querySelectorAll('.color-picker__swatch');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      // Swatches
      if (swatches.length) {
        swatches.forEach(swatch => {
          swatch.addEventListener('click', () => {
            const selectedId = swatch.dataset.variant;
            // Swatches
            swatches.forEach(swatch => {
              swatch.querySelector('.color-picker__swatch-color').classList.remove('color-picker__swatch-color--active');
            });
            swatch.querySelector('.color-picker__swatch-color').classList.add('color-picker__swatch-color--active');

            // Images
            if (upsell.querySelector(`#image-${selectedId}`)) {
              const image = upsell.querySelector(`#image-${selectedId}`).dataset.image;
              imageWrapper.innerHTML = image;
            }

            // ACT button
            actButton.dataset.variantUpsell = swatch.dataset.variant;
          });
        });
      }

      // ACT button
      actButton.addEventListener('click', () => {
        actButton.classList.add('loading');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const items = [
          {
            'id': actButton.dataset.variantUpsell,
            'quantity': 1
          },
          {
            'id': actButton.dataset.variant,
            'quantity': 1
          }
        ];
        const formData = new FormData();
        buildFormData(formData, 'items', items);
        formData.append('section-id', actButton.dataset.sectionId);
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          actButton.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
      });
    });
  }
}

function buildFormData(formData, key, data) {
  if (data === Object(data) || Array.isArray(data)) {
    for (const i in data) buildFormData(formData, `${key}[${i}]`, data[i]);
  } else {
    data && formData.append(key, data);
  }
}

upsellingItemsFn();